import css from "./LastCommentsBlock.module.css";

import { Link } from "react-router";
import {
  getCommentObject,
  getCommentPreview,
  LastCommentWithObject,
} from "../site/Comments";
import { useTurl } from "~/util/Lang";

export function LastCommentsBlock(props: {
  comments: LastCommentWithObject[];
}) {
  const turl = useTurl();
  return (
    <div>
      <h2 className={css.title}>Latest Comments</h2>
      <section className={css.root}>
        {props.comments.map((comment) => (
          <Comment key={comment.id} comment={comment} />
        ))}
      </section>
    </div>
  );
}

function Comment(props: { comment: LastCommentWithObject }) {
  const comment = props.comment;

  const { link, path } = getCommentObject(comment);

  return (
    <Link className={css.item} to={path + `/comments#comment-${comment.id}`}>
      <div className={css.header}>
        <div className={css.titleLink}>{link}</div>
        <div className={css.type}>
          <span>{comment._}</span>
          <span className={css.gver}>{comment.game}</span>
        </div>
      </div>
      <div className={css.body}>{getCommentPreview(comment.content)}</div>
    </Link>
  );
}
